import { create } from 'zustand';

export type SessionWarningLevel = null | 'yellow' | 'red';

interface SessionExpiryState {
  warningLevel: SessionWarningLevel;
  expTimeUTC: number | null;
  dismissed: boolean;
  setWarning: (level: SessionWarningLevel, expTimeUTC: number) => void;
  dismiss: () => void;
  clear: () => void;
}

export const useSessionExpiryStore = create<SessionExpiryState>()(set => ({
  warningLevel: null,
  expTimeUTC: null,
  dismissed: false,
  setWarning: (level, expTimeUTC) => set({ warningLevel: level, expTimeUTC, dismissed: false }),
  dismiss: () => set({ dismissed: true }),
  clear: () => set({ warningLevel: null, expTimeUTC: null, dismissed: false }),
}));
